import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center">
                <i className="ri-book-read-line text-2xl text-primary-500"></i>
              </span>
              <span className="font-heading text-lg text-foreground-900 whitespace-nowrap">
                打屁股漫画精选
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              精选海量打屁股漫画内容，涵盖搞笑、萌系、剧情多种风格，持续更新最新资源，带你发现最有趣的打屁股漫画世界。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">
              漫画分类
            </h4>
            <ul className="space-y-2">
              {categories
                .filter((c) => c.slug !== "all")
                .map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                    >
                      {cat.name}漫画
                    </Link>
                  </li>
                ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/category/all"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  全部漫画
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">
              热门标签
            </h4>
            <div className="flex flex-wrap gap-2">
              {["搞笑", "萌系", "剧情", "治愈", "日常", "校园"].map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 bg-background-200/70 rounded-full text-xs text-foreground-600 whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 打屁股漫画精选合集. 版权所有.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
            >
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}